import { ChartNoAxesCombined, CircleDollarSign, SearchCheck } from "lucide-react";
import pandaSeo from "../../assets/images/Panda/red-panda-computer.png";
import ResponsiveImage from "../common/ResponsiveImage";

const seoBenefits = [
  {
    title: "Tăng cơ hội lên top đầu kết quả tìm kiếm",
    icon: SearchCheck,
  },
  {
    title: "Tăng lưu lượng truy cập website và tỷ lệ chuyển đổi",
    icon: ChartNoAxesCombined,
  },
  {
    title: "Không phải tiêu tốn nhiều ngân sách cho quảng cáo",
    icon: CircleDollarSign,
  },
];

const SectionWebsiteSeo: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-[linear-gradient(135deg,#f36a5b_0%,#e44739_52%,#d63124_100%)] py-12 sm:py-13 lg:py-14">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 opacity-[0.1]">
          <div
            className="h-full w-full"
            style={{
              backgroundImage:
                "linear-gradient(rgba(255,255,255,0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.07) 1px, transparent 1px)",
              backgroundSize: "120px 120px",
            }}
          />
        </div>
        <div className="absolute left-0 top-0 h-full w-full bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.06),transparent_62%)]" />
      </div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6">
        <div className="grid items-center gap-6 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1fr)] lg:gap-10">
          <div className="order-2 text-left lg:order-1">
            <h2 className="max-w-[520px] text-[25px] font-semibold leading-[1.18] text-white sm:text-[31px] lg:text-[38px]">
              Thiết Kế Website Chuẩn SEO Là Gì?
            </h2>

            <p className="mt-4 max-w-[620px] text-[14px] leading-7 text-white/90 sm:text-[15px]">
              Thiết kế website chuẩn SEO là tối ưu hóa website thân thiện với các công cụ tìm kiếm
              (Google, Bing,...). Đây là tiêu chuẩn các website hiện nay cần phải đạt, giúp bộ máy tìm
              kiếm dễ dàng thu thập dữ liệu và hiểu toàn bộ website nhanh hơn.
            </p>

            <div className="mt-6 grid gap-3 sm:grid-cols-3">
              {seoBenefits.map(({ title, icon: Icon }) => (
                <article
                  key={title}
                  className="rounded-[18px] bg-white px-3.5 py-3.5 text-left shadow-[0_16px_28px_rgba(127,29,29,0.12)]"
                >
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-red-50 text-red-600">
                    <Icon size={17} />
                  </div>
                  <p className="mt-3 text-[13.5px] font-medium leading-6 text-[#2f1a1a]">{title}</p>
                </article>
              ))}
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <ResponsiveImage
              src={pandaSeo}
              alt="Thiết kế website chuẩn SEO TrioCore Solutions"
              className="mx-auto h-auto w-full max-w-[500px] object-contain lg:max-w-[480px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionWebsiteSeo;
